import { createContext } from "react";
import type { LayoutContextType } from "../types/contexts";

export const LayoutContext = createContext<LayoutContextType | undefined>(
  undefined
);
